// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
/*引入Animate.css*/
import animated from 'animate.css'
/*放大镜*/
import VuePhotoZoomPro from 'vue-photo-zoom-pro'
import axios from 'axios'
import $ from 'jquery'
/*svg*/
import './icons'

Vue.prototype.$axios = axios;
Vue.use(VuePhotoZoomPro);
Vue.use(animated);
Vue.use(VideoPlayer);


Vue.use(ViewUI);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js